import { useMutation, useQueryClient } from "@tanstack/react-query"
import { verifyOtp } from "@/api"

export const useVerifyOtp = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, otp, userType }: { userId: number; otp: string; userType: string }) =>
      verifyOtp({ userId, otp, userType }),

    onSuccess: (user) => {
      // cache the authenticated user in react-query
      queryClient.setQueryData(["user"], user);
    },
  })
}